<template>
  <v-chip
    class="ui-chip"
    v-bind="$attrs"
    v-on="$listeners"
    :color="backgroundColor"
    :text-color="textColor"
    label
    :ripple="false"
  >
    <template v-for="(_, name) in $slots" v-slot:[name]>
      <slot :name="name" />
    </template>
  </v-chip>
</template>

<script>
import { getReadableTextColor } from '@/helpers/partner-categories'

export default {
  name: 'UiChip',
  props: {
    status: {
      type: [Boolean, String],
      default: true,
    },
    riskLevel: {
      type: Boolean,
      default: false,
    },
    score: {
      type: [Number, String],
      default: 0,
    },
    categoryColor: {
      type: String,
      default: '',
    },
  },
  computed: {
    backgroundColor() {
      if (this.categoryColor) {
        return this.categoryColor
      }
      if (this.riskLevel) {
        switch (+this.score) {
          case 0:
            return 'gray100'
          case 1:
          case 2:
            return 'green100'
          case 3:
          case 4:
            return 'yellow100'
          default:
            return 'red100'
        }
      } else {
        switch (this.status) {
          case true:
            return 'green100'
          case 'updated':
            return 'yellow100'
          default:
            return 'gray100'
        }
      }
    },
    textColor() {
      if (this.categoryColor) {
        return getReadableTextColor(this.categoryColor)
      }
      if (this.riskLevel) {
        switch (+this.score) {
          case 0:
            return 'gray900'
          case 1:
          case 2:
            return 'green800'
          case 3:
          case 4:
            return 'yellow800'
          default:
            return 'red800'
        }
      } else {
        switch (this.status) {
          case true:
            return 'green800'
          case 'updated':
            return 'yellow800'
          default:
            return 'gray900'
        }
      }
    },
  },
}
</script>

<style lang="scss">
.ui-chip {
  height: 22px !important;
  border-radius: 6px !important;
  .v-chip__content {
    font-weight: 500;
    font-size: 12px;
  }
}
</style>
